import { Radio } from "antd/es";
import { Guid } from "guid-typescript";
import { PureComponent, ReactNode } from "react";
import isEqual from "react-fast-compare";
import { CommonProps } from "../../../components/web-components/common/common-props";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import DynamicStyleManager from "../../../shared/utilty/dynamic-style-manager";

declare const window: {
  kuika: {
    isDesignTime: boolean;
  };
};

interface IKRadioButtonProps {
  selectedButtonColor: string;
  selectedButtonBgColor: string;
  splitterColor: string;
  label: string;
  value: string;
  style: any;
  tabIndex?: number;
}

interface IKRadioButtonState {}

class KRadioButton extends PureComponent<IKRadioButtonProps & CommonProps, IKRadioButtonState> {
  private uniqueKey = Guid.create();

  private style = new DynamicStyleManager(`kradiobutton_${this.uniqueKey}`);

  constructor(props: IKRadioButtonProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.setDynamicStyle();
  }

  componentDidUpdate(prevProps: IKRadioButtonProps) {
    if (!isEqual(prevProps, this.props)) {
      this.setDynamicStyle();
    }
  }

  componentWillUnmount() {
    this.style.removeStyle();
  }

  getDynamicCss = (): string => {
    const className: string = this.getClassName();
    if (!className || className.length === 0) {
      return "";
    }
    let result = "";
    const { paddingTop, paddingBottom, color, fontSize, fontWeight, fontFamily, width, height } = this.props.style;
    if (paddingTop === 8 && paddingBottom === 8) {
      result += `.${className.trim()} {
          padding: 4px 8px !important;
        }`;
    }
    if (color) {
      result += `.${className.trim()} {
          color: ${color} !important;
        }`;
    }
    if (fontSize) {
      result += `.${className.trim()} {
          font-size: ${fontSize} !important;
        }`;
    }
    if (fontWeight) {
      result += `.${className.trim()} {
          font-weight: ${fontWeight} !important;
        }`;
    }
    if (fontFamily) {
      result += `.${className.trim()} {
          font-family: ${fontFamily} !important;
        }`;
    }
    if (width) {
      result += `.${className.trim()} {
          width: ${width} !important;
          display: inline-block !important;
        }`;
    }
    if (height) {
      result += `.${className.trim()} {
          height: ${height} !important;
          display: inline-block !important;
        }`;
    }
    return result;
  };

  setDynamicStyle = () => {
    this.style.setDynamicCss(this.getDynamicCss());
  };

  getClassName = () => {
    let result = "";
    if (!this.uniqueKey) {
      return result;
    }
    result = `${result} kradiobutton_${this.uniqueKey.toString().substring(0, 8)}`;
    return result;
  };

  getLabel = (label: string): string => {
    const labelStr = label == null ? "" : String(label);
    if (!window.kuika?.isDesignTime) return labelStr;
    if (!labelStr.includes(":") || labelStr.length < 10) return labelStr;

    return `${labelStr.substring(0, 10)}...`;
  };

  render(): ReactNode {
    return (
      <Radio.Button
        className={this.getClassName()}
        value={this.props.value}
        style={this.props.style}
        onClick={this.props.onClick}
        tabIndex={this.props.tabIndex}
      >
        {this.getLabel(this.props.label)}
      </Radio.Button>
    );
  }
}

const kRadioButton = withCommonEvents(KRadioButton);
export { kRadioButton as KRadioButton };
